// 新方法，通过params传递command
const n_nativeAction = (params) => {
  try {
    window.webkit.messageHandlers.nativeAction.postMessage(JSON.stringify(params));
  } catch (e) {
    console.log('iOS调用两端新方法失败,参数为：', params)
  }
  try {
    window.LiveAppJS.nativeAction(JSON.stringify(params));
  } catch (e) {
    console.log('Android调用两端新方法失败,参数为：', params)
  }
  return params
}
module.exports = {
  n_nativeAction
}